import L from 'leaflet'
import { isEmpty } from 'lodash-unified'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { CommUtils } from '@map-sdk/sdk/utils/CommUtils'
import { ShipxyOptions } from '@map-sdk/sdk/config'
import { TideService } from '@map-sdk/sdk/plugins/weather/Tides/TideService'
import { typhoonInfoList } from '@map-sdk/sdk/plugins/weather/Typhoon/TyphonInfoList'
import {
  SeaAreaForecastService,
  SeaForecast,
} from '@map-sdk/sdk/plugins/weather/Sea/SeaAreaForecastService'
import { FullScreenSymbol } from '@map-sdk/sdk/plugins/weather/util/FullScreenSymbol'
import { ShowFullScreenTitleLayer } from '@map-sdk/sdk/plugins/weather/util/ShowFullScreenTitleLayer'
import { windyService } from '@map-sdk/sdk/plugins/weather/Weather/WindyService'
import { TyphoonService } from '@map-sdk/sdk/plugins/weather/Typhoon/TyphoonService'
import type { TyphonInfoList } from '@map-sdk/sdk/plugins/weather/Typhoon/TyphonInfoList'
import type {
  PathPoint,
  TyphoonDetails,
} from '@map-sdk/sdk/plugins/weather/Typhoon/TyphoonService'
import type { SeaForecastInterFaca } from '@map-sdk/sdk/plugins/weather/Sea/SeaAreaForecastService'
import type { WindyService } from '@map-sdk/sdk/plugins/weather/Weather/WindyService'
import type { LTileLayerFunctionalOptions } from '@map-sdk/sdk/plugins/weather/util/ShowFullScreenTitleLayer'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

type WeatherServiceOptions = LTileLayerFunctionalOptions

export class WeatherServiceImpl extends ShowFullScreenTitleLayer {
  private _QBBeginTime: any
  private _refash_QBBeginTime: number | undefined
  private _SeaBreezes?: FullScreenSymbol
  private _SeaWater?: FullScreenSymbol
  private _RainFall?: FullScreenSymbol
  private _TyphoonInfoList?: TyphonInfoList // 需要具体类型定义
  private _windFiel?: WindyService
  private _oceanCurrentFiel?: WindyService
  private _haiquyubao: SeaAreaForecastService = new SeaAreaForecastService(
    this._map
  )
  private _tideService?: TideService
  private _typhoon: TyphoonService | undefined

  constructor(map: MyMap, options?: WeatherServiceOptions) {
    super(map, options)
    this._QBBeginTime = {}
  }

  /**
   * 通用方法 显示
   * 水温 0
   * 冰情 1
   * 海冰 2
   * 海风 3
   * 海风箭头 4
   * 降雨量 5
   * 气压 6
   * 能见度 7
   * 气温 8
   * 海浪 9
   * 海浪箭头 10
   * @param type
   * @param time
   */
  public showWeatherLayerTile(type: string, time: string): void {
    CanvasShipUtils.openLoadingPopup(50, () => {
      try {
        this.updateQBBeginTime()
        this.showFullScreenTileLayer(type, time, this._QBBeginTime)
      } catch (e) {
        console.error(e)
      }
      CanvasShipUtils.closeLoadingPopup()
    })
  }

  public hideWeatherLayerTile(type?: string) {
    this.hideFullScreenTileLayer(type)
    CanvasShipUtils.closeLoadingPopup()
  }

  // 显示气温面的逻辑
  public showTempTile(time: string): void {
    CanvasShipUtils.openLoadingPopup(50, () => {
      try {
        this.updateQBBeginTime()
        this.showFullScreenTileLayer('12', time, this._QBBeginTime)
      } catch (e) {
        console.error(e)
      }
      CanvasShipUtils.closeLoadingPopup()
    })
  }
  // 隐藏气温面的逻辑
  public hideTempTile(): void {
    this.hideFullScreenTileLayer()
    CanvasShipUtils.closeLoadingPopup()
  }

  /**
   * 显示气压面
   */
  showPressureTile(time: any) {
    CanvasShipUtils.openLoadingPopup(50, () => {
      try {
        this.updateQBBeginTime()
        this.showFullScreenTileLayer('11', time, this._QBBeginTime)
      } catch (e) {
        console.error(e)
      }
      CanvasShipUtils.closeLoadingPopup()
    })
  }
  /**
   *  隐藏气压面
   */
  hidePressureTile() {
    this.hideFullScreenTileLayer()
    CanvasShipUtils.closeLoadingPopup()
  }
  /**
   * 显示海风符号
   */
  showSeaBreezes(time: string, data: any) {
    CanvasShipUtils.openLoadingPopup(50, () => {
      try {
        this.updateQBBeginTime()
        this._SeaBreezes ||
          (this._SeaBreezes = new FullScreenSymbol(this._map, 13, data))
        this._SeaBreezes.show(time, this._QBBeginTime)
      } catch (e) {
        console.error(e)
      }
      CanvasShipUtils.closeLoadingPopup()
    })
  }
  /**
   * 隐藏海风符号
   */
  hideSeaBreezes() {
    this._SeaBreezes && this._SeaBreezes.remove()
    CanvasShipUtils.closeLoadingPopup()
  }

  /**显示海流符号 */
  showSeaWater(time: any, data: any) {
    CanvasShipUtils.openLoadingPopup(50, () => {
      try {
        this.updateQBBeginTime()
        this._SeaWater ||
          (this._SeaWater = new FullScreenSymbol(this._map, 15, data))
        this._SeaWater.show(time, this._QBBeginTime)
      } catch (e) {
        console.error(e)
      }
      CanvasShipUtils.closeLoadingPopup()
    })
  }
  /**隐藏海流符号 */
  hideSeaWater() {
    this._SeaWater && this._SeaWater.remove()
    CanvasShipUtils.closeLoadingPopup()
  }
  /**显示降水符号 */
  showRainFall(time: any) {
    CanvasShipUtils.openLoadingPopup(50, () => {
      try {
        this.updateQBBeginTime()
        this._RainFall || (this._RainFall = new FullScreenSymbol(this._map, 16))
        this._RainFall.show(time, this._QBBeginTime)
      } catch (error) {
        console.error(error)
      }
      CanvasShipUtils.closeLoadingPopup()
    })
  }
  /**隐藏降水符号 */
  hideRainFall() {
    this._RainFall && this._RainFall.remove()
    CanvasShipUtils.closeLoadingPopup()
  }
  getTyphoonInfo(
    item: any,
    isChecked: boolean,
    closeCallback: any,
    showWinList: any,
    noIngCallback: any,
    cbLoadData: any,
    other: any
  ) {
    if (!this._TyphoonInfoList) {
      this._TyphoonInfoList = typhoonInfoList(this._map, {
        ...other,
        weatherService: this,
        closeCallback,
        noIngCallback,
        showWinList,
        cbLoadData,
      })
    }
    // lastValueFrom(getWeatherTyphoonDetail({ tfbh: item.id }))
    this._TyphoonInfoList.selectItem(item, isChecked)
  }
  /**显示台风列表控件 */
  showTyphoonInfoList(
    closeCallback: any,
    showWinList: any,
    noIngCallback: any,
    cbLoadData: any,
    other: any
  ) {
    CanvasShipUtils.openLoadingPopup(50, () => {
      try {
        if (!this._TyphoonInfoList) {
          this._TyphoonInfoList = typhoonInfoList(this._map, {
            ...other,
            weatherService: this,
            closeCallback,
            noIngCallback,
            showWinList,
            cbLoadData,
          })
        }
        this._TyphoonInfoList.show()
      } catch (e) {
        console.error(e)
      }
      CanvasShipUtils.closeLoadingPopup()
    })
  }
  /**隐藏台风列表控件 */
  hideTyphoonInfoList() {
    this._TyphoonInfoList && this._TyphoonInfoList.remove()
    this.hideTyphoon()
    CanvasShipUtils.closeLoadingPopup()
  }
  /**显示风场 */
  showWindFiel(forecastTime: string, data?: any) {
    CanvasShipUtils.openLoadingPopup(50, () => {
      try {
        this.updateQBBeginTime()
        this._windFiel ||
          (this._windFiel = windyService(this._map, {
            type: 13,
            data,
          }))
        this._windFiel.show(forecastTime, this._QBBeginTime)
      } catch (error) {
        console.error(error)
      }
      CanvasShipUtils.closeLoadingPopup()
    })
  }
  /**隐藏风场 */
  hideWindFiel() {
    this._windFiel && this._windFiel.hide()
    CanvasShipUtils.closeLoadingPopup()
  }
  /**洋流 */
  showOceanCurrentFiel(layer: any, data: any) {
    CanvasShipUtils.openLoadingPopup(50, () => {
      try {
        this.updateQBBeginTime()
        this._oceanCurrentFiel ||
          (this._oceanCurrentFiel = windyService(this._map, {
            type: 15,
            data,
          }))
        this._oceanCurrentFiel.show(layer, this._QBBeginTime)
      } catch (e) {
        console.error(e)
      }
      CanvasShipUtils.closeLoadingPopup()
    })
  }
  hideOceanCurrentFiel() {
    this._oceanCurrentFiel && this._oceanCurrentFiel.hide()
    CanvasShipUtils.closeLoadingPopup()
  }
  /**显示海区预报 */
  showSeaAreaForecasts(
    getDataListFunction: (done: (data: SeaForecastInterFaca[]) => void) => void,
    cbFunction?: (params: any) => void
  ) {
    CanvasShipUtils.openLoadingPopup(50, () => {
      try {
        const done = (data: SeaForecastInterFaca[]) => {
          // 全部
          this._haiquyubao.addSeaForecasts(4, this.dealSeaForecastData(data))
          cbFunction && this._haiquyubao.addEventCallbackListener(cbFunction)
        }
        getDataListFunction(done)

        // const jinhaiUrl = ShipxyOptions.weather.jinhaiUrl
        // //近海
        // this._haiquyubao.addSeaForecasts(
        //   2,
        //   this.dealSeaForecastData(weatherData['2'].data)
        // )

        // //沿岸
        // const yananUrl = ShipxyOptions.weather.yananUrl
        // this._haiquyubao.addSeaForecasts(
        //   1,
        //   this.dealSeaForecastData(weatherData['1'].data)
        // )

        // //远海
        // const yuanhaiUrl = ShipxyOptions.weather.yuanhaiUrl
        // this._haiquyubao.addSeaForecasts(
        //   3,
        //   this.dealSeaForecastData(weatherData['3'].data)
        // )

        // console.log(
        //   'TODO: showSeaAreaForecasts',
        //   jinhaiUrl,
        //   yananUrl,
        //   yuanhaiUrl
        // )

        this._map.off('zoomend', this._showSeaAreaForecasts_zoomend, this)
        this._map.on('zoomend', this._showSeaAreaForecasts_zoomend, this)
      } catch (error) {
        console.error(error)
      }
    })
  }
  _showSeaAreaForecasts_zoomend() {
    this._haiquyubao && this._haiquyubao._drawSeaForecasts()
  }
  dealSeaForecastData(list: SeaForecastInterFaca[]): SeaForecast[] {
    const seaForecasts: SeaForecast[] = []
    for (const item of list) {
      const seaForecast = new SeaForecast()
      seaForecast.seaarea = item.seaarea
      seaForecast.centerlatitude = `${item.centerlatitude}`
      seaForecast.centerlongititude = item.centerlongititude
      seaForecast.publishtime = item.publishtime
      if (item.publishtime) {
        seaForecast.publishdate = new Date(
          item.publishtime.split('日')[0].replace('年', '-').replace('月', '-')
        )
        const weatherdetailList: WeatherDetail[] = []
        if (item.weatherdetail && item.weatherdetail.length > 0)
          for (let j = 0; j < item.weatherdetail.length; j += 2) {
            const weatherDetail = new WeatherDetail()
            L.Util.extend(weatherDetail, item.weatherdetail[j])
            if (!CommUtils.isEmpty(weatherDetail.forecastaging)) {
              if (0 == j) {
                weatherDetail.publishdate = seaForecast.publishdate
                weatherDetail.publishtime = CommUtils.dataFormat(
                  weatherDetail.publishdate,
                  'MM月DD日'
                )
                seaForecast.forecastaging_str = '未来24小时'
              }
              if (2 == j) {
                weatherDetail.publishdate = new Date(
                  seaForecast.publishdate.getTime() + 86400000
                )
                weatherDetail.publishtime = CommUtils.dataFormat(
                  weatherDetail.publishdate,
                  'MM月DD日'
                )
                seaForecast.forecastaging_str = '未来48小时'
              }
              if (4 == j) {
                weatherDetail.publishdate = new Date(
                  seaForecast.publishdate.getTime() + 172800000
                )
                weatherDetail.publishtime = CommUtils.dataFormat(
                  weatherDetail.publishdate,
                  'MM月DD日'
                )
                seaForecast.forecastaging_str = '未来72小时'
              }

              weatherDetail.meteorological_icon =
                item.weatherdetail[j].meteorological
              weatherDetail.meteorological =
                item.weatherdetail[j].meteorological
              CanvasShipUtils.isEmpty(item.weatherdetail[j].meteorological) ||
                item.weatherdetail[j].meteorological ==
                  item.weatherdetail[j + 1].meteorological ||
                (weatherDetail.meteorological =
                  `${item.weatherdetail[j].meteorological} ` +
                  `转` +
                  ` ${item.weatherdetail[j + 1].meteorological}`)
              weatherDetail.winddirection = item.weatherdetail[j].winddirection
              CanvasShipUtils.isEmpty(item.weatherdetail[j].winddirection) ||
                item.weatherdetail[j].winddirection ==
                  item.weatherdetail[j + 1].winddirection ||
                (weatherDetail.winddirection =
                  `${item.weatherdetail[j].winddirection} ` +
                  `转` +
                  ` ${item.weatherdetail[j + 1].winddirection}`)
              weatherDetail.windpower = item.weatherdetail[j].windpower
              CanvasShipUtils.isEmpty(item.weatherdetail[j].windpower) ||
                item.weatherdetail[j].windpower ==
                  item.weatherdetail[j + 1].windpower ||
                (weatherDetail.windpower =
                  `${item.weatherdetail[j].windpower} ` +
                  `转` +
                  ` ${item.weatherdetail[j + 1].windpower}`)
              weatherDetail.visibility = item.weatherdetail[j].visibility
              CanvasShipUtils.isEmpty(item.weatherdetail[j].visibility) ||
                item.weatherdetail[j].visibility ==
                  item.weatherdetail[j + 1].visibility ||
                (weatherDetail.visibility =
                  `${item.weatherdetail[j].visibility} ` +
                  `转` +
                  ` ${item.weatherdetail[j + 1].visibility}`)
              weatherDetail.waveheight = `${item.weatherdetail[j].waveheight}`
              CanvasShipUtils.isEmpty(item.weatherdetail[j].waveheight) ||
                item.weatherdetail[j].waveheight ==
                  item.weatherdetail[j + 1].waveheight ||
                (weatherDetail.waveheight =
                  `${item.weatherdetail[j].waveheight} ` +
                  `转` +
                  ` ${item.weatherdetail[j + 1].waveheight}`)
              weatherdetailList.push(weatherDetail)
            }
          }
        seaForecast.weatherdetail = weatherdetailList as any
        weatherdetailList.length > 0 &&
          (seaForecast.meteorological =
            weatherdetailList[0].meteorological_icon)
        seaForecasts.push(seaForecast)
      }
    }
    return seaForecasts
  }
  /**隐藏海区预报 */
  hideSeaAreaForecasts() {
    this._haiquyubao && this._haiquyubao.close()
    this._map.off('zoomend', this._showSeaAreaForecasts_zoomend, this)
    CanvasShipUtils.closeLoadingPopup()
  }
  /**显示潮汐预报 */
  showTides() {
    CanvasShipUtils.openLoadingPopup(50, () => {
      try {
        this._tideService || (this._tideService = new TideService(this._map))
        this._tideService.addTides()
      } catch (error) {
        console.error(error)
      }
      CanvasShipUtils.closeLoadingPopup()
    })
  }
  /**隐藏潮汐预报 */
  hideTides() {
    this._tideService && this._tideService.close()
    CanvasShipUtils.closeLoadingPopup()
  }
  /**
   * 显示台风
   * @param pathPoints
   * @param typhoonDetails
   */
  showTyphoon(
    pathPoints: PathPoint[],
    typhoonDetails: TyphoonDetails,
    options: any
  ) {
    this._typhoon || (this._typhoon = new TyphoonService(this._map, options))
    return this._typhoon.showTyphoon(pathPoints, typhoonDetails)
  }

  _parseRawTyphoon(rawTyphoonData: any, options: any) {
    this._typhoon || (this._typhoon = new TyphoonService(this._map, options))
    return this._typhoon.parseRawTyphoon(rawTyphoonData)
  }
  hideTyphoon(type?: string) {
    try {
      if (this._typhoon) {
        CanvasShipUtils.isEmpty(type) && (type = 'all')
        this._typhoon.hideTyphoon(type)
        'all' == type && (this._typhoon = undefined)
      }
    } catch (error) {
      console.error(error)
    }
    CanvasShipUtils.closeLoadingPopup()
  }
  updateQBBeginTime() {
    if (
      !(
        (ShipxyOptions.versionType &&
          ShipxyOptions.versionType.includes('API')) ||
        (this._refash_QBBeginTime &&
          Date.now() - this._refash_QBBeginTime < 3600000)
      )
    ) {
      // $.ajax({
      //   url: ShipxyOptions.weather.getQBBeginTimeURL,
      //   timeout: 5000,
      //   success: (res: { status: number; data: string | any[] }) => {
      //     if (res && 0 == res.status && res.data) {
      //       for (let i = 0; i < res.data.length; i++) {
      //         const item = res.data[i]
      //         const typeStr = 'type_' + item.type
      //         this._QBBeginTime[typeStr] = item
      //       }
      //       this._refash_QBBeginTime = new Date().getTime()
      //     }
      //   },
      //   error() {
      //     console.error('[气象服务]获取起报时间错误')
      //   }
      // })
      console.log(
        'TODO: updateQBBeginTime',
        ShipxyOptions.weather.getQBBeginTimeURL
      )
      return this._QBBeginTime
    }
  }
  /**获取鼠标位置，经纬度对应的气象数据 */
  getLatLngWeather(type: string, latlng: any, sTime: string | Date) {
    const result = null
    if (isEmpty(latlng)) return result
    if (isEmpty(sTime)) {
      sTime = this.getCurDate()
      latlng = L.latLng(latlng)
      this.updateQBBeginTime()
    }
    const types = `${type}`.split(',')
    const times: string[] = []
    if (
      ShipxyOptions.versionType &&
      !ShipxyOptions.versionType.includes('API')
    ) {
      for (const type_ of types) {
        let date = `${CanvasShipUtils.dataFormat(
          new Date(),
          'YYYY-MM-DD'
        )} 20:00:00`
        const typeStr = `type_${type_}`
        if (this._QBBeginTime && typeStr in this._QBBeginTime) {
          date = this._QBBeginTime[typeStr].time
          times.push(date)
        }
      }
    }
    const url = ShipxyOptions.weather.getLatLngWeatherURL
      .replace('{type}', type)
      .replace('{time}', times.join(','))
      .replace('{forecasttime}', sTime.toString())
      .replace('{x}', `${CanvasShipUtils.lngTo180(latlng.lng)}`)
      .replace('{y}', latlng.lat)
    console.log('TODO:', url)
    return result
  }
  /**获取鼠标位置，经纬度对应的气象数据 */
  // getLatLngWeatherAPI(
  //   type: string,
  //   latlng:
  //     | string
  //     | number
  //     | string[]
  //     | L.LatLngLiteral
  //     | L.LatLngTuple
  //     | null
  //     | undefined,
  //   sTime: string | number | string[] | Date | null | undefined,
  //   cb: (arg0: any) => void
  // ) {
  //   let result = null
  //   if (CommUtils.isEmpty(latlng)) return result
  //   if (CommUtils.isEmpty(sTime)) {
  //     sTime = this.getCurDate()
  //     latlng = L.latLng(latlng)
  //     this.updateQBBeginTime()
  //   }
  //   const types = (type + '').split(',')
  //   const times = []
  //   if (
  //     ShipxyOptions.versionType &&
  //     ShipxyOptions.versionType.indexOf('API') < 0
  //   ) {
  //     for (let i = 0; i < types.length; i++) {
  //       let date =
  //         CanvasShipUtils.dataFormat(new Date(), 'YYYY-MM-DD') + ' 20:00:00'
  //       const typeStr = 'type_' + types[i]
  //       if (this._QBBeginTime && typeStr in this._QBBeginTime) {
  //         date = this._QBBeginTime[typeStr].time
  //         times.push(date)
  //       }
  //     }
  //     if (types.length != times.length) {
  //       console.error('气象栅格图层，气象类型与起报时间不成对！')
  //       return
  //     }
  //   }
  //   const url = ShipxyOptions.weather.getLatLngWeatherURLAPI
  //     .replace('{k}', '07b733dd6c0d4d74bd25dbbe2049d4c7')
  //     .replace('{lon}', CanvasShipUtils.lngTo180(latlng.lng))
  //     .replace('{lat}', latlng.lat)
  //     .replace('{time}', sTime)
  //   if ($.isFunction(cb)) {
  //     jQuery.getJSON(url, function (res: any) {
  //       cb(res)
  //     })
  //   } else {
  //     jQuery.ajaxSettings.async = false
  //     jQuery.getJSON(url, function (res: any) {
  //       result = res
  //     })
  //     jQuery.ajaxSettings.async = true
  //   }

  //   return result
  // }
  /**
   * @retrun 2018-05-15 20:00:00
   */
  getCurDate(nowDate?: Date, isNow?: boolean): string | Date {
    !nowDate && (nowDate = new Date())
    !isNow && (isNow = true)
    let curDate: Date | string = ''
    const dateList: string[] = []
    const nowDateFormat = CommUtils.dataFormat(nowDate, 'YYYY-MM-DD')
    dateList.push(
      `${CommUtils.dataFormat(
        nowDate.getTime() - 34560000,
        'YYYY-MM-DD'
      )} 20:00:00`,
      `${nowDateFormat} 02:00:00`,
      `${nowDateFormat} 08:00:00`,
      `${nowDateFormat} 14:00:00`,
      `${nowDateFormat} 20:00:00`,
      `${CommUtils.dataFormat(
        nowDate.getTime() + 34560000,
        'YYYY-MM-DD'
      )} 02:00:00`
    )
    for (let i = 0; i < dateList.length; i++) {
      curDate = new Date(dateList[i].replace(/\\-/g, '/'))
      if (curDate.getTime() >= nowDate.getTime()) {
        if (isNow) {
          curDate = dateList[i]
          break
        }
        curDate = dateList[i - 1]
        break
      }
    }
    return curDate
  }
  /** 隐藏所有显示 */
  hideAll() {
    this.hideTempTile()
    this.hidePressureTile()
    this.hideSeaBreezes()
    this.hideSeaWater()
    this.hideRainFall()
    this.hideTides()
    this.hideSeaAreaForecasts()
    this.hideTyphoonInfoList()
    this.hideWindFiel()
    this.hideWeatherLayerTile()
  }
}

/**
 * 天气数据服务
 */
export class WeatherDataServer {
  ValueCountByType: {
    11: number
    12: number
    13: number
    14: number
    15: number
    16: number
    18: number
  }
  constructor() {
    this.ValueCountByType = {
      11: 1,
      12: 1,
      13: 2,
      14: 3,
      15: 2,
      16: 1,
      18: 1,
    }
  }

  weatherDataAnalysis = (resData: any, valueCount: number) => {
    const weatherDatas = []
    for (let i = 0; i < 65160; i++) {
      const values = []
      for (let i = 0; i < valueCount; i++) {
        values.push(resData.readFloat32LE().toFixed(5))
      }
      weatherDatas.push({
        value: values.join('/'),
        x: 1000 * ((i % 360) - 180),
        y: 1000 * (Number.parseInt(`${i / 360}`) + -90),
      })
    }
    return weatherDatas
  }
}

/**
 * 天气明细实体
 */
export class WeatherDetail {
  publishtime = ''
  publishdate: Date | null = null
  forecastaging = ''
  forecastaging_str = ''
  meteorological = ''
  visibility = ''
  waveheight = ''
  winddirection = ''
  windpower = ''
  meteorological_icon: any
}
